import { IconButton, TableCell, TableRow, Tooltip, Typography } from "@material-ui/core";
import { Equalizer, FiberManualRecord, RadioButtonUnchecked } from "@material-ui/icons";
import { IFeatureDto } from "../../Types/ABTests";
import { useStyles } from "./BaseClientTableCell";

export default function ABTestingFeatureTableCell({
  columns,
  element,
  index,
  customRowProps,
}: {
  columns: TableColumn[];
  element: IFeatureDto & Record<string, any>;
  index: number;
  customRowProps?: any;
}) {
  const classes = useStyles();

  function displayDistribution() {
    const Icon =
      element.distribution === "Custom" ? (
        <FiberManualRecord color="primary" fontSize="small" />
      ) : (
        <RadioButtonUnchecked color="secondary" fontSize="small" />
      );
    const tooltipText =
      element.distribution === "Custom" ? "Custom Distribution Overridden" : "Default Distribution";
    return (
      <Tooltip title={tooltipText} placement="right" arrow>
        <Typography style={{ display: "inline-flex", alignItems: "center", lineHeight: 1, gap: 1 }}>
          {Icon}
          {element.distribution}
        </Typography>
      </Tooltip>
    );
  }

  return (
    <>
      <TableRow
        hover
        key={element.featureName}
        className={index % 2 ? classes.rowCell : classes.rowCellOdd}
        data-test="ab-testing-feature-table-row"
        onClick={() => {
          customRowProps?.onClick?.(element);
        }}
      >
        {columns.map((column: TableColumn) => (
          <TableCell key={`${element.featureName}:${column.propName}`} align="left">
            {column.propName === "" ? (
              <IconButton
                style={{
                  border: "2px solid rgba(0,0,0,0.3)",
                }}
              >
                <Equalizer />
              </IconButton>
            ) : column.propName === "distribution" ? (
              displayDistribution()
            ) : (
              element[column.propName]
            )}
          </TableCell>
        ))}
      </TableRow>
    </>
  );
}
